import { AirPlayToggleButton, Button, CastToggleButton, ControlBar, FullscreenToggleButton, PictureInPictureToggleButton, PlaybackToggleButton, SettingsToggleButton, VolumeToggleButton } from 'bitmovin-player-ui';
import { sendCustomMessage } from '../../nativemobileuicontainer';
import { CustomMessages } from '../../../types/interfaces';
import { ViewMode } from 'bitmovin-player';
const interval = 10;
function rewind(player) {
    if (player.isLive()) {
        player.timeShift(player.getTimeShift() - interval);
    }
    else {
        player.seek(Math.max(0, player.getCurrentTime() - interval));
    }
}
function forward(player) {
    if (player.isLive()) {
        player.timeShift(Math.min(0, player.getTimeShift() + interval));
    }
    else {
        player.seek(Math.min(player.getDuration(), player.getCurrentTime() + interval));
    }
}
const watchFromStartButtonClickHandler = () => {
    sendCustomMessage(CustomMessages.CLICK_WATCH_FROM_START);
};
function createBigPlayToggleButton() {
    const bigPlayToggleButton = new PlaybackToggleButton({
        cssClass: 'ui-playbacktogglebutton'
    });
    const bigPlaybackClickHandler = () => {
        if (!bigPlayToggleButton)
            return;
        sendCustomMessage(CustomMessages.TOGGLE_PLAY_PAUSE, { isChecked: !bigPlayToggleButton.isOn() });
    };
    bigPlayToggleButton.onClick.unsubscribe(() => {
        bigPlaybackClickHandler();
    });
    bigPlayToggleButton.onClick.subscribe(() => {
        bigPlaybackClickHandler();
    });
    return bigPlayToggleButton;
}
export function createForwardButton(player) {
    const forwardButton = new Button({
        cssClass: 'ui-forwardbutton bmpui-ui-button',
        ariaLabel: 'Spoel 10 seconden vooruit'
    });
    if (player) {
        forwardButton.onClick.subscribe(() => {
            forward(player);
        });
    }
    return forwardButton;
}
export function createRewindButton(player) {
    const rewindButton = new Button({
        cssClass: 'ui-rewindbutton bmpui-ui-button',
        ariaLabel: 'Spoel 10 seconden terug'
    });
    if (player) {
        rewindButton.onClick.subscribe(() => {
            rewind(player);
        });
    }
    return rewindButton;
}
export function createMiddleButtons(player) {
    const bigPlayToggleButton = createBigPlayToggleButton();
    const bigRewindButton = createRewindButton(player);
    const bigForwardButton = createForwardButton(player);
    return new ControlBar({
        components: [bigRewindButton, bigPlayToggleButton, bigForwardButton],
        cssClasses: ['controlbar-middle']
    });
}
export function createWatchFromStartButton() {
    const watchFromStartButton = new Button({
        cssClass: 'ui-textbutton ui-watchfromstartbutton bmpui-ui-button',
        text: 'Kijk vanaf het begin',
        ariaLabel: 'Kijk vanaf het begin',
        hidden: true
    });
    watchFromStartButton.onClick.subscribe(() => {
        watchFromStartButtonClickHandler();
    });
    watchFromStartButton.onClick.unsubscribe(() => {
        watchFromStartButtonClickHandler();
    });
    return watchFromStartButton;
}
export function createGoBackLiveButton(player) {
    const goBackLiveButton = new Button({
        cssClass: 'ui-textbutton ui-backtolivebutton bmpui-ui-button',
        text: 'Terug naar live',
        ariaLabel: 'Terug naar live',
        hidden: true
    });
    const goBackLiveButtonClickHandler = () => {
        const result = sendCustomMessage(CustomMessages.CLICK_GO_BACK_TO_LIVE);
        if (result.defaultActionRequired === false && player.isLive()) {
            player.timeShift(0);
        }
    };
    goBackLiveButton.onClick.unsubscribe(() => {
        goBackLiveButtonClickHandler();
    });
    goBackLiveButton.onClick.subscribe(() => {
        goBackLiveButtonClickHandler();
    });
    return goBackLiveButton;
}
export function createSettingsButton(settingsPanel) {
    const customSettingsToggleButton = new SettingsToggleButton({ settingsPanel });
    const settingsButtonClickHandler = () => {
        if (!customSettingsToggleButton || !settingsPanel)
            return;
        const clickPromise = new Promise((resolve, reject) => {
            const result = sendCustomMessage(CustomMessages.TOGGLE_SETTINGS_PANEL, {
                isChecked: !settingsPanel.isShown()
            });
            if (result.defaultActionRequired === true) {
                reject(result);
            }
            else {
                resolve(result);
            }
        });
        clickPromise
            .then(() => {
            settingsPanel.hide();
            customSettingsToggleButton.off();
        })
            .catch(() => {
            console.warn('Settings button function is not overwritten.');
        });
    };
    customSettingsToggleButton.onClick.unsubscribe(() => {
        settingsButtonClickHandler();
    });
    customSettingsToggleButton.onClick.subscribe(() => {
        settingsButtonClickHandler();
    });
    return customSettingsToggleButton;
}
export function createPlaybackToggleButton() {
    const customPlayerbackToggleButton = new PlaybackToggleButton({
        cssClass: 'ui-playbacktogglebutton'
    });
    const playbackClickHandler = () => {
        if (!customPlayerbackToggleButton)
            return;
        sendCustomMessage(CustomMessages.TOGGLE_PLAY_PAUSE, { isChecked: !customPlayerbackToggleButton.isOn() });
    };
    customPlayerbackToggleButton.onClick.unsubscribe(() => {
        playbackClickHandler();
    });
    customPlayerbackToggleButton.onClick.subscribe(() => {
        playbackClickHandler();
    });
    return customPlayerbackToggleButton;
}
export function createVolumeToggleButton(player) {
    const customVolumeToggleButton = new VolumeToggleButton();
    const volumeClickHandler = () => {
        if (!customVolumeToggleButton)
            return;
        sendCustomMessage(CustomMessages.TOGGLE_MUTE, { isChecked: !player.isMuted() });
    };
    customVolumeToggleButton.onClick.unsubscribe(() => {
        volumeClickHandler();
    });
    customVolumeToggleButton.onClick.subscribe(() => {
        volumeClickHandler();
    });
    return customVolumeToggleButton;
}
export function createPictureInPictureToggleButton(player) {
    const customPictureInPictureToggleButton = new PictureInPictureToggleButton();
    const pictureInPictureClickHandler = () => {
        if (!customPictureInPictureToggleButton)
            return;
        sendCustomMessage(CustomMessages.TOGGLE_PIP, { isChecked: player.getViewMode() !== ViewMode.PictureInPicture });
    };
    customPictureInPictureToggleButton.onClick.unsubscribe(() => {
        pictureInPictureClickHandler();
    });
    customPictureInPictureToggleButton.onClick.subscribe(() => {
        pictureInPictureClickHandler();
    });
    return customPictureInPictureToggleButton;
}
export function createAirPlayToggleButton() {
    const customAirPlayToggleButton = new AirPlayToggleButton();
    const airPlayClickHandler = () => {
        if (!customAirPlayToggleButton)
            return;
        sendCustomMessage(CustomMessages.TOGGLE_AIRPLAY, { isChecked: customAirPlayToggleButton.isOn() });
    };
    customAirPlayToggleButton.onClick.unsubscribe(() => {
        airPlayClickHandler();
    });
    customAirPlayToggleButton.onClick.subscribe(() => {
        airPlayClickHandler();
    });
    return customAirPlayToggleButton;
}
export function createCastToggleButton() {
    const customCastToggleButton = new CastToggleButton();
    const castClickHandler = () => {
        if (!customCastToggleButton)
            return;
        sendCustomMessage(CustomMessages.CLICK_CAST, { isChecked: customCastToggleButton.isOn() });
    };
    customCastToggleButton.onClick.unsubscribe(() => {
        castClickHandler();
    });
    customCastToggleButton.onClick.subscribe(() => {
        castClickHandler();
    });
    return customCastToggleButton;
}
export function createFullscreenToggleButton(player) {
    const customFullscreenToggleButton = new FullscreenToggleButton();
    const fullscreenClickHandler = () => {
        sendCustomMessage(CustomMessages.TOGGLE_FULLSCREEN, { isChecked: player.getViewMode() !== ViewMode.Fullscreen });
    };
    customFullscreenToggleButton.onClick.unsubscribe(() => {
        fullscreenClickHandler();
    });
    customFullscreenToggleButton.onClick.subscribe(() => {
        fullscreenClickHandler();
    });
    return customFullscreenToggleButton;
}
